// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { AiFlowNodeCategorySchema } from '../inputTypeSchemas/AiFlowNodeCategorySchema'

/////////////////////////////////////////
// CODE GRAPH SCHEMA
/////////////////////////////////////////

export const CodeGraphSchema = z.object({
  aiFlowNodeType: AiFlowNodeCategorySchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  entryPointsNodeIds: z.string().array(),
  description: z.string(),
  method: z.string().nullable(),
  path: z.string().nullable(),
  queryParams: z.string().array(),
  bodyParams: z.string().array(),
  headerParams: z.string().array(),
  cookieParams: z.string().array(),
  pathParams: z.string().array(),
  aiFlowGraphId: z.string().nullable(),
  aiFlowNodeId: z.string().nullable(),
  isOutdated: z.boolean(),
  outdatedReason: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type CodeGraph = z.infer<typeof CodeGraphSchema>

export default CodeGraphSchema;
